import serviceAnnouncements from './service-announcements';
export default serviceAnnouncements;
